export default __webpack_public_path__ + "static/media/Rectangle 1010.e5a3fd07.png";